export const REGEX = {
  ONLY_LETTERS: /^[aA-zZ\s]+$/,
  CITY_REGEX: /^[aA-zZ'.\s]+$/,
};
